import React from 'react';
import { Copy, Forms, Modal, SaveButton } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import { getPermissions } from 'helpers/permissions';
import { useDispatch } from 'react-redux';
import { apiPatch } from 'services';
import { setShowSuccess, toggleFormHelp } from 'actions/ui';
import { setUserAvatar } from 'actions/user';
import posthog from 'posthog-js';

export const Motivators = ({ text, profile }) => {
    const dispatch = useDispatch();

    const [saving, setSaving] = React.useState(false);
    const [goals, setGoals] = React.useState('');
    const [show, setShow] = React.useState(false);
    const { coaching, downline, user } = useSelector(state => state.user);
    const { tags, handles } = useSelector(state => state.ui);
    const [permissions, setPermissions] = React.useState(getPermissions());

    const save = () => {
        profile.goals = goals;

        apiPatch('profile-goals', profile, user.guid, () => {
            dispatch(setShowSuccess(text.goals.success));
            dispatch(setUserAvatar(profile.avatar));
            setSaving(false);
            setShow(false);
            posthog.capture('personal-goals-saved');
        });
    };

    React.useEffect(() => {
        if (show) {
            setGoals(profile?.goals);
        }
    }, [show, profile]);

    React.useEffect(() => {
        if (profile?.id && user?.id) {
            setPermissions(getPermissions(profile, user, coaching, downline));
        }
    }, [profile?.id, user?.id]);

    const footer = (
        <div>
            <SaveButton
                id="image-save-button"
                data-testid="btn-save-motivator"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={save}
            >
                {text.goals.buttons.save}
            </SaveButton>
            <button data-testid="btn-cancel-motivator" className="btn" onClick={() => setShow(false)}>
                {text.goals.buttons.cancel}
            </button>
        </div>
    );

    return (
        <>
            <div data-testid="user121-goals-box" className="goals pt10">
                <Copy
                    value={
                        profile.goals
                            ? profile.goals
                            : profile?.id === user?.id
                              ? text.goals.none.you
                              : text.goals.none.them(profile.first_Name)
                    }
                />
            </div>
            {permissions.one2ones.canEditPersonalGoals && (
                <button
                    data-testid="btn-edit-personal-goal"
                    className="btn btn-primary text-sm mt20 mb10"
                    onClick={() => setShow(true)}
                >
                    {text.goals.edit}
                </button>
            )}
            <Modal
                show={show}
                title={text.goals.title}
                close={() => setShow(false)}
                footer={footer}
                toggleFormHelp={() => dispatch(toggleFormHelp())}
            >
                <Forms.Textarea
                    help={text.goals.field.help}
                    placeholder={text.goals.field.placeholder}
                    rows="10"
                    value={goals}
                    onChange={setGoals}
                    label={text.goals.field.label}
                    data-testid="text-goals"
                    tags={tags}
                    handles={handles}
                />
            </Modal>
        </>
    );
};

export default Motivators;
